module.exports = __webpack_public_path__ + "img/growthAbility1.f153e789.png";